import { RootState } from '../../rootReducer';

export const commentsSelectors = {
  getComments: (state: RootState) => state.CommentsState.comments,
};
